export default __webpack_public_path__ + "static/media/profileImg9.6b99f3db.png";